import React, { Component } from 'react'

export default class Team extends Component {
    render() {
        return (
            <>
                <hr/>
                <div className="container">

                    <center><h3>CONVERSE 2K19 TEAM</h3></center>
                    
                    <div className="row mt-5">
                        <div className="col-12 pt-0 pl-2 pr-2">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-users"></i>
                                </div>
                                <h4>CONVERSE 2k19</h4>
                                <b>HEAD OF THE DEPARTMENT</b>
                                <br/>Prof. (Dr.) Vivaksha Jariwala
                                <br/> 
                                <br/>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Hiren Vavaiya 
                                <br/> Prof. Dhanlakshmi Manikraj
                                <br/>
                                <br/><b>Student Conveners</b>
                                <br/> Raj Dhanani (7048866119)
                                <br/> Jinam Mehta (8758643441)
                                <br/> Samarth Mehta (9979912226) 
                                <br/> 
                                <br/><b>Non technical events contacts</b>
                                <br/> Prince Ghoghari (9687333010)
                                <br/> Nirav Sutariya (9638445306)
                                <br/>   
                                <br/><b>Graphic-Design Head (tech)</b>
                                <br/> Bhagyesh Jahangirpuria
                                <br/>   
                                <br/><b>Graphic-Design Head (non-tech)</b>
                                <br/> Akash Lakhani     
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-black-tie"></i>
                                </div>
                                <h4>PY IT</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. (Dr.) Mita Parikh
                                <br/> Prof. Mukesh Patel  
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Pranav Desai 
                                <br/> Ayush Vyas  
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-codiepie"></i>
                                </div>
                                <h4>C Quiz</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Mukesh Patel  <br/>
                                {/* <br/> Prof. Tushar Gohil */}
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Ashish Chovatiya
                                <br/> Shreya Brahmbhatt
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-laptop"></i>
                                </div>
                                <h4>IT Quiz</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Ashish Kharvar
                                <br/> Prof. Apurva Mandalaywala
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Arpan Korat
                                <br/> Parth Buha   
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-code"></i>
                                </div>
                                <h4>WYSIWYG</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Bhumika Patel  
                                <br/> Prof. Tushar Gohil
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Akash Chovatiya
                                <br/> Jainil Sevalia
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-terminal"></i>
                                </div>
                                <h4>Relay Coding</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Tushar Gohil<br/>
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Riddhi Chodvadiya 
                                <br/> Vishal Tailor
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 pt-0 pl-2 pr-2 ml-auto mr-auto">
                            <div className="iconBox" style = {obj}>
                                <div className = "icon">
                                    <i className="fa fa-paint-brush"></i>
                                </div>
                                <h4>Image IT</h4>
                                <b>Faculty Coordinators</b>
                                <br/> Prof. Dhruti Sharma
                                <br/> Prof. Dhanalakshmi Manikraj
                                <br/><br/><b>Student Event Heads</b>
                                <br/> Siddharth Simediya
                                <br/> Moksha Shah   
                            </div>
                        </div>
                        
                    </div>
                </div>
            </>
        )
    }
}

var obj = {
    marginTop : "50px",
    border : "1px #f0f0f0 solid",
    paddingTop : "50px",
    paddingLeft : "10px",
    paddingRight : "10px",
    paddingBottom : "10px",
    backgroundColor : "#f9f9f9",
    textAlign : "center",
    verticalAlign : "middle"
}